<template>
	<div :class="{'-mt-16': !hasMedia}">
		<DomPlayer v-if="showDomRecording" />
		<VideoPlayer v-if="showVideo" class="session-media-background w-full" />
		<Screenshot
			v-if="showScreenshot"
			class="session-media-background w-full"
			@expand="$emit('expand')"
			@minimize="$emit('minimize')"
		/>
		<div
			v-if="isLoading && hasMedia"
			:style="{aspectRatio: loadingPlaceholderAspectRatio}"
			class="session-media-loading session-media-background"
		>
			<p><BaseIcon name="mono/load" class="mr-8" />Loading...</p>
		</div>
	</div>
</template>

<script>
import DomPlayer from 'shared/components/DomPlayer.vue'
import VideoPlayer from 'shared/components/VideoPlayer.vue'
import Screenshot from 'shared/components/Screenshot.vue'
import {useSessionStore} from 'shared/stores/session'

export default {
	name: 'SessionMedia',
	components: {
		VideoPlayer,
		Screenshot,
		DomPlayer,
	},
	emits: ['expand', 'minimize'],
	setup() {
		return {sessionStore: useSessionStore()}
	},
	data() {
		return {
			isLoading: true,
			mediaType: this.$route.query.mediaType,
		}
	},
	computed: {
		session() {
			return this.sessionStore.session
		},
		hasMedia() {
			if (this.$store.isExtension) return true
			return this.session.video || this.session.screenshot || this.session.domEvents
		},
		showVideo() {
			if (this.session?.video != undefined) return Boolean(this.session.video)
			if (this.$store.isExtension) return Boolean(!this.mediaType || this.mediaType === 'Video')
			return false
		},
		showScreenshot() {
			if (this.session?.screenshot != undefined) return Boolean(this.session.screenshot)
			if (this.$store.isExtension) return this.mediaType === 'Screenshot'
			return false
		},
		showDomRecording() {
			if (this.session?.domEvents != undefined) return Boolean(this.session.domEvents)
			if (this.$store.isExtension) {
				return Boolean(
					this.session.isInstantReplay && (!this.mediaType || this.mediaType === 'Replay recording')
				)
			}
			return false
		},
		loadingPlaceholderAspectRatio() {
			const {windowWidth, windowHeight, videoWidth, videoHeight} = this.session
			if (this.showVideo && videoWidth && videoHeight) return `${videoWidth}/${videoHeight}`
			return `${windowWidth}/${windowHeight}`
		},
	},
	async created() {
		document.addEventListener('sessionDomEventsLoaded', this.onDomEventsLoaded)
		document.addEventListener('sessionVideoLoaded', this.onVideoLoaded)
		document.addEventListener('sessionScreenshotLoaded', this.onScreenshotLoaded)
	},
	unmounted() {
		document.removeEventListener('sessionDomEventsLoaded', this.onDomEventsLoaded)
		document.removeEventListener('sessionVideoLoaded', this.onVideoLoaded)
		document.removeEventListener('sessionScreenshotLoaded', this.onScreenshotLoaded)
	},
	methods: {
		onDomEventsLoaded(event) {
			if (!event.detail.hasDomEvents) return
			this.mediaType = 'Replay recording'
			this.isLoading = false
		},
		onVideoLoaded(event) {
			if (!event.detail.hasVideo) return
			this.mediaType = 'Video'
			this.isLoading = false
		},
		onScreenshotLoaded(event) {
			if (!event.detail.screenshot) return
			this.mediaType = 'Screenshot'
			this.isLoading = false
		},
	},
}
</script>

<style>
.session-media-background {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
}

.session-media-loading {
	background-color: var(--gray-800);
	color: var(--gray-300);
	border-radius: 8px;
	border: 1px solid var(--gray-600);
}
</style>
